import { render } from "./Footer.vue?vue&type=template&id=70a49083&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=70a49083&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70a49083"

export default script